module.exports = __webpack_public_path__ + "static/semaphore-logo-f118579c3b54165ce6e93fd56a3c4c78.png";